import YkcInput from './src/ykc-input.vue';

YkcInput.install = function install(_vue) {
  _vue.component(YkcInput.name, YkcInput);
};
export default YkcInput;
